// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class Accordion extends Component {
  #triggerEl: HTMLElement;
  #collapseEl: HTMLElement;
  #clickHandler: function;
  #id: ?string;

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    const trigger: HTMLElement | null = pEl.querySelector('[ref="trigger"]');
    const collapsible: HTMLElement | null = pEl.querySelector('[ref="collapsible"]');

    if (trigger && collapsible) {
      this.#triggerEl = trigger;
      this.#collapseEl = collapsible;
    } else {
      throw new Error('Accordion failure');
    }

    this.#clickHandler = this.handleClick.bind(this);
    this.#triggerEl.addEventListener(EventNames.CLICK, this.#clickHandler);

    const id = this.el.dataset.id;
    if (id) {
      this.#id = id;
    }
  }

  /**
   * Executes when the user clicks on the accordion
   */
  handleClick(): void {
    this.el.classList.toggle('show');
    if (this.#id) {
      this.notify(Notifications.TOGGLE_ACCORDION, { identifier: this.#id, isOpen: !this.el.classList.contains('show') });
    }
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    document.removeEventListener(EventNames.CLICK, this.#clickHandler);
    super.destroy();
  }
}
